import React from 'react';

export const AdminLayout: React.FC = ({ children }) => (
    <>
        <div style={{ display: 'none' }} data-test-id="admin-layout"></div>
        {children}
    </>
);
